import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { toggleSiderBar } from '../../redux/modules'
import "./index.scss";


export default function Hamburger(props){
  const dispatch = useDispatch()
  const sidebarCollapsed = useSelector(state=>state.switcher.sidebarCollapsed)
  const _toggleSiderBar = () => {
    dispatch(toggleSiderBar())
  }
  return (
    <div className="hamburger-container" onClick={_toggleSiderBar}>
      {sidebarCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
    </div>
  );
};